export enum CommonActions {
  Cancel = 'GXZu',
  Submit = 'FV+B',
  Reset = '2u52',
  ResetLowercase = 'Ab4w',
  Apply = 'MeOS',
  Select = 'KngC',
}
